import styled from "styled-components";
import { $SearchPageTemplate } from "../styles";

export const $TypeExpressCode = styled<any>($SearchPageTemplate)`
`;